import { Button } from "@blueprintjs/core"
import { useState } from "react"
import { NAVIGATION_DESIGN_TYPE } from "src/libs/useful/gallery/Gallery"
import { ICWProps } from "."

/* Protopia Ecosystem component */ 
const NavDesignHandler = (props: ICWProps): JSX.Element => {
    const [ values, ] = useState<NAVIGATION_DESIGN_TYPE[]>( Object.values( NAVIGATION_DESIGN_TYPE).map( val => val ) )
    const onChange = () => {
        const index = values.findIndex(v => v ===  props.carousel_nav_type) || 0
        const next = (index + 1) % values.length
        props.onChange( {
            ...props,
            carousel_nav_type: values[next] 
        })
    }
    return <>
         <Button variant="minimal" size="small" className="btn-stretch px-2" onClick={onChange} >
            <img src={ `/assets/img/landing/${ props.carousel_nav_type }.svg` } height={22} alt="" />
        </Button> 
    </>
}
export default NavDesignHandler